import styled from "@emotion/styled"
import BackgroundPattern from "../../components/background-pattern/background-pattern.component"
import { IconButton, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"
import CustomVideo from "../../components/custom-video/custom-video.component"

export const Section = styled(BackgroundPattern)`
  padding-top: ${({ theme }) => theme.typography.pxToRem("53")};
  padding-bottom: ${({ theme }) => theme.typography.pxToRem("110")};
  border-radius: 48px 48px 0px 0px;
  background: #f2f6ff;
  overflow: hidden;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: ${({ theme }) => theme.typography.pxToRem("148")};
    padding-bottom: 10rem;
  }
  ::before {
    opacity: 0.44;
    background-size: 256px auto;
    ${({ theme }) => theme.breakpoints.up("md")} {
      background-size: 289px auto;
    }
  }
  .MuiContainer-root {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const FactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const FactIcon = styled(CustomImage)`
  display: flex;
  margin-bottom: 1.5rem;
  width: 60px;
  height: 60px;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    width: 82px;
    height: 82px;
    margin-bottom: ${({ theme }) => theme.typography.pxToRem("27")};
  }
`

export const FactTitle = styled(Typography)`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 1.5rem;
  line-height: ${({ theme }) => theme.typography.pxToRem("35")};
  letter-spacing: 0.36px;
  margin-bottom: 0.75rem;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    margin-bottom: ${({ theme }) => theme.typography.pxToRem("15")};
  }
`

export const FactDescription = styled(Typography)`
  text-align: center;
  letter-spacing: 0.255px;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: ${({ theme }) => theme.typography.pxToRem("17")};
    line-height: 1.75rem;
  }
`

export const VideoSection = styled.div`
  position: relative;
  margin-top: 5.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5.25rem 1.25rem;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: ${({ theme }) => theme.typography.pxToRem("178")} 2.5rem;
    margin-top: ${({ theme }) => theme.typography.pxToRem("136")};
  }
`

export const Video = styled(CustomVideo)`
  position: absolute;
  z-index: -1;
  inset: 0;
  border-radius: 20px;
  overflow: hidden;
  video {
    object-fit: cover;
  }
  ::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 0.2) 100%
      ),
      linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
      linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
      linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%);
  }
`

export const VideoTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.light};
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 2rem;
  line-height: ${({ theme }) => theme.typography.pxToRem("44")};
  margin-bottom: 1.75rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem("44")};
    line-height: ${({ theme }) => theme.typography.pxToRem("60")};
    margin-bottom: 2.5rem;
    max-width: 692px;
  }
`

export const VideoDescription = styled.div`
  color: ${({ theme }) => theme.palette.text.light};
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem("26")};
  letter-spacing: 0.16px;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 1.125rem;
    line-height: ${({ theme }) => theme.typography.pxToRem("34")};
    letter-spacing: 0.18px;
    max-width: 692px;
  }
`

export const SliderTitle = styled(Typography)`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 2.25rem;
  line-height: ${({ theme }) => theme.typography.pxToRem("52")};
  margin-top: 5.5rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem("52")};
    margin-top: ${({ theme }) => theme.typography.pxToRem("180")};
  }
`

export const SliderWrapper = styled.div`
  margin-top: 2.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    margin-top: 5.75rem;
  }
  .swiper {
    width: 100%;
    max-width: 785px;
  }
`

export const SlideIcon = styled(CustomImage)`
  margin-bottom: 1.75rem;
  img {
    width: 100%;
    max-height: 100px;
    max-width: 200px;
    ${({ theme }) => theme.breakpoints.up("md")} {
      max-width: 500px;
    }
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    margin-bottom: 2.25rem;
  }
`

export const Slide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const SlideDescription = styled(Typography)`
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem("17")};
  font-weight: 600;
  line-height: 1.75rem;
  margin-bottom: 0.75rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem("22")};
    font-weight: 600;
    line-height: ${({ theme }) => theme.typography.pxToRem("34")};
    margin-bottom: 1.25rem;
  }
`

export const SlideAuthor = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem("15")};
  font-weight: 500;
  line-height: 1.5rem;
  letter-spacing: 0.225px;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 1.125rem;
    line-height: 1.75rem;
    letter-spacing: 0.27px;
  }
`

export const ArrowsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2rem;
  /* gap: 0.5rem; */
  ${({ theme }) => theme.breakpoints.up("sm")} {
    margin-top: 3rem;
  }
`

export const Arrow = styled(IconButton)`
  &.prev {
    transform: rotate(180deg);
  }
  &.swiper-button-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    svg {
      width: 48px;
      height: 48px;
    }
  }
`

export const ArrowCount = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.content};
  font-size: ${({ theme }) => theme.typography.pxToRem("22")};
  font-weight: 600;
  line-height: 1.75rem;
  letter-spacing: 0.33px;
  width: auto;
  text-align: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 1.75rem;
    line-height: 2rem;
    letter-spacing: 0.42px;
  }
`

export const BottomTitle = styled(Typography)`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 2.25rem;
  line-height: 3rem;
  margin-top: ${({ theme }) => theme.typography.pxToRem("102")};
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 765px;
    margin-top: 9.5rem;
    font-size: ${({ theme }) => theme.typography.pxToRem("56")};
    line-height: 4.5rem;
  }
`

export const ButtonsWrapper = styled.div`
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 0 2rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 0;
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
  }
  a,
  button {
    display: flex;
    align-items: center;
    gap: 10px;
    ${({ theme }) => theme.breakpoints.down("sm")} {
      width: 100%;
    }
  }
  .icon {
    display: flex;
  }
`
